var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "ads"
  }, [_c("Title", {
    staticClass: "ads_title",
    attrs: {
      title: _vm.title
    }
  }), _c("section", {
    staticClass: "ads_content"
  }, _vm._l(_vm.adslist, function (item) {
    return _c("div", {
      key: item.title,
      class: ["item", {
        itemcls: _vm.itemcls
      }]
    }, [_c("img", {
      attrs: {
        src: item.img,
        alt: "item.title"
      }
    }), _c("div", {
      staticClass: "item_content"
    }, [_c("span", {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _c("span", {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.desc))])])]);
  }), 0)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };